import botsTemplate from './bots.html';

const SELECTED_BOT_LOCAL_STORAGE_KEY = 'Selected-Bot';

export default angular
  .module('main.locations.edit.tabs.bots', [])

  .directive('editLocationBotsTab', () => {
    return {
      restrict: 'E',
      template: botsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $state,
                   $filter,
                   utils,
                   ToastsService,
                   config,
                   EditLocationDataProvider) => {
        const $t = $filter('translate');
        const $date = $filter('date');
        $scope.dateFormat = $t('datetime.mdyHMS12');
        $scope.dataProvider = EditLocationDataProvider.instance;

        $scope.botStatuses = config.getConfigByKey('botInstanceStatuses');

        angular.extend($scope, {
          onAddNewBotsButtonClick: onAddNewBotsButtonClick,
          onViewBotButtonClick: onViewBotButtonClick,
          onDeleteBotButtonClick: onDeleteBotButtonClick,
          onToggleBotStatusButtonClick: onToggleBotStatusButtonClick,
          filterByBotStatus: filterByBotStatus,
          canToggleBotStatus: canToggleBotStatus,
          getBotEndDateDesc: getBotEndDateDesc
        });

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationBotInstancesResource.init(),
            $scope.dataProvider.isBotsAvailableForLocationResource.init(),
            $scope.dataProvider.locationResource.init()
          ])
            .then(() => {
              initViewModel();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });
        }

        function initViewModel() {
          $scope.bots = angular.copy($scope.dataProvider.locationBotInstancesResource.value);
        }

        function filterByBotStatus(item) {
          if ($scope.selectedBotStatusObj) {
            return $scope.selectedBotStatusId === item.status;
          }
          return true;
        }

        function onAddNewBotsButtonClick() {
          if ($scope.loading) {
            return;
          }

          $state.go('main.bots.list', {
            from: 'location',
            locationId: $scope.dataProvider.locationIdResource.value
          });
        }

        function onViewBotButtonClick(bot) {
          if ($scope.loading || !bot) {
            return;
          }

          utils.setStorageItem(SELECTED_BOT_LOCAL_STORAGE_KEY, bot);
          $state.go('main.bots.info', {
            from: 'location',
            locationId: $scope.dataProvider.locationIdResource.value
          });
        }

        function canToggleBotStatus(botInstance) {
          const status = botInstance.status;
          if (status !== 1 && !!botInstance.endDateMs && botInstance.endDateMs <= new Date().getTime()) {
            // The user should not be able to activate the bot instance if the endDate has already passed.
            return false;
          }
          return true;
        }

        function onToggleBotStatusButtonClick(bot) {
          if ($scope.loading || !bot || !canToggleBotStatus(bot)) {
            return;
          }

          let newStatus = bot.status === 1 ? 2 : 1;

          $scope.loading = true;
          return $scope.dataProvider.setLocationBotStatus(bot, newStatus)
            .then(() => {
              ToastsService.success();
              initViewModel();
              $scope.loading = false;
            }, err => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function getBotEndDateDesc(botInstance) {
          const isPassed = botInstance.endDateMs <= new Date().getTime();
          const dateStr = $date(botInstance.endDateMs, $scope.dateFormat);
          return $t(isPassed ? 'bots.endDatePassed' : 'bots.endDateFuture', { date: dateStr });
        }

        function onDeleteBotButtonClick(bot) {
          if ($scope.loading || !bot) {
            return;
          }

          $scope.botDeleteMsg = $t('bots.delete.desc', {
            bot: bot.bot.name || bot.bot.bundle,
            target: $scope.dataProvider.locationResource.value?.name,
            type: $t('locations.list.locationId') + $scope.dataProvider.locationIdResource.value
          });

          $('#remove-bot-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              $('#remove-bot-dialog').modal('hide');
              $scope.loading = true;
              return $scope.dataProvider.removeLocationBotInstance(bot)
                .then(() => {
                  $('#remove-bot-dialog').modal('hide');
                  ToastsService.success($t('bots.delete.success'), $t('bots.delete.successDesc'));
                  initViewModel();
                  $scope.loading = false;
                }, err => {
                  $('#remove-bot-dialog').modal('hide');
                  utils.handleApiError(err);
                  $scope.loading = false;
                });
            }
          }).modal('show');
        }
      }
    };
  })
  .name;
